import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import withRouter from 'react-router/lib/withRouter';
import Link from 'react-router/lib/Link';

class Gripsize extends Component {
	
    state = {
    	core_region: '',
        left_finger_size: '',
    	right_finger_size: '',
        left_palm_width: '',
    	right_palm_width: '',
    }

    onChange = (e) => {
    	const { name, value } = e.target;
    	this.setState({
    		[name]: value
    	})
    }

    handleSubmit = (e) => {
    	e.preventDefault();
    	const { storeGripsize } = this.props;
    	storeGripsize(this.state);
    }

    componentWillMount() {
        const { getGripsize } = this.props;
        getGripsize(this.state);
    }

    componentWillReceiveProps(nextProps) {
        const { gripsize } = nextProps;
        this.setState(gripsize);
    }   

    render(){

    	return (
    		<div className="panel-custom-wrapper">
				<div className="panel panel-custom">
					<div className="panel-heading">Gripsize</div>
					<form onSubmit={this.handleSubmit}>
						<div className="panel-body">
							<div className="row">
								<div className="col-md-12 col-xs-12">
									<div className="form-group">
										<label>Core Region *</label>
										<input 
											required={true}
											value={this.state.core_region}
											onChange={this.onChange}
											type="number" 
											name="core_region"
											className="form-control form-custom"
											/>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-md-6 col-xs-12">
									<div className="form-group">
										<label>Left Finger Size *</label>
										<input 
											required={true}
											value={this.state.left_finger_size}
											onChange={this.onChange}
											type="number" 
											name="left_finger_size"
											className="form-control form-custom"
											/>
									</div>
								</div>
                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>Right Finger Size *</label>
                                        <input 
                                            required={true}
                                            value={this.state.right_finger_size}
                                            onChange={this.onChange}
                                            type="number" 
                                            name="right_finger_size"
                                            className="form-control form-custom"
                                            />
                                    </div>
                                </div>
                            </div>
							<div className="row">
								<div className="col-md-6 col-xs-12">
									<div className="form-group">
										<label>Left Palm Width *</label>
										<input 
											required={true}
											value={this.state.left_palm_width}
											onChange={this.onChange}
											type="number" 
											name="left_palm_width"
											className="form-control form-custom"
											/>
									</div>
								</div>
                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>Right Palm Width *</label>
                                        <input 
                                            required={true}
                                            value={this.state.right_palm_width}
                                            onChange={this.onChange}
                                            type="number" 
                                            name="right_palm_width"
                                            className="form-control form-custom"
                                            />
                                    </div>
                                </div>
                            </div>
						</div>
						<div className="btn-custom text-right panel-footer">
                            <Link className="btn btn-primary" to="/profile">Cancel</Link>{' '}
                            <button disabled={ this.props.isWaiting } className="btn btn-success">
                            	{ this.props.isWaiting 
                            		? 'Loading...'
                            		: 'Proceed'
                            	}
                            </button>
                        </div>
					</form>
				</div>
			</div>
    	)
	}
}


export default withRouter(connect(
	(state, routeParams) => {
		const { isWaiting } = state.onWaiting;
		const { params } = routeParams;
        const { gripsize } = state.gripsize;
      
		return {
            isWaiting,
            params,
            gripsize
		}
	},
	actions
)(Gripsize))


// WEBPACK FOOTER //
// ./src/gripsize/containers/Gripsize.js